import { render, staticRenderFns } from "./BusinessInitialSetup.vue?vue&type=template&id=526c83f4&scoped=true"
import script from "./BusinessInitialSetup.vue?vue&type=script&lang=js"
export * from "./BusinessInitialSetup.vue?vue&type=script&lang=js"
import style0 from "./BusinessInitialSetup.vue?vue&type=style&index=0&id=526c83f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c83f4",
  null
  
)

export default component.exports